import axios from 'axios'
import utils from '@/libs/utils'
import store from '@/store/index'

let instance = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT, //process.env.API_ROOT,
  timeout: 180 * 1000,
  withCredentials: true,
  responseType: 'json'
})

instance.interceptors.request.use(config => {
  if (localStorage) {
    let SHAREDJSESSIONID = utils.getToken(config.url)
    if (SHAREDJSESSIONID !== null && SHAREDJSESSIONID != '') {
      config.headers.Authorization = SHAREDJSESSIONID
    }
  }
  return config
}, error => {
  console.log(error)
  return Promise.reject(error)
})

instance.interceptors.response.use(async response => {
  if (response.status >= 200 && response.status < 300) {
    store.dispatch('refreshToken')
    if (response.config.responseType != 'json') {
      return response
    } else {
      return response.data
    }
  } else {
    return { status: response.status, msg: 'err' }
  }
}, error => {
  //token过期 重新登陆
  console.log('error', error)
  if (error.response.status == 401) {
    window.localStorage.clear()
    setTimeout(function () {
      window.location.href = '/login'
    }, 500)
  } else if (error.response.status == 403) {
    window.localStorage.clear()
    setTimeout(function () {
      window.location.href = '/login?kickout=1'
    }, 500)
  }
  return Promise.reject(error)
})

export default instance